import type { ShellHandle } from '@/views/app-shell';

let handle: ShellHandle | null = null;

export function setShell(h: ShellHandle): void { handle = h; }
export function getShell(): ShellHandle | null { return handle; }
